import { MessageActions, TuaPayLoanIframeMessage, TuapayLoanRequestContext, TuapayPaymentData } from '../types';


export const getLoanRequestDetails = async ({
  sessionId,
  libInitializeId,
}: {
  sessionId: string;
  libInitializeId: string;
}) => {
  return new Promise<TuapayLoanRequestContext>((resolve) => {
    const onMessage = (event: MessageEvent) => {
      if (event.data?.action === MessageActions.TUAPAY_LOAN_REQUEST_DETAILS) {
        window.removeEventListener('message', onMessage);
        resolve(event.data.data);
        clearTimeout(timerId);
      }
    };

    window.addEventListener('message', onMessage);

    const timerId = setTimeout(() => {
      window.removeEventListener('message', onMessage);
      resolve({});
    }, 5_000);

    window.parent.postMessage({
      action: MessageActions.TUAPAY_GET_LOAN_REQUEST_DETAILS,
      sessionId,
      libInitializeId,
    }, '*');
  });
};

export const preparePaymentData = (message: TuaPayLoanIframeMessage): TuapayPaymentData => {
  const { command, data: { loan_id, approved, params } } = message;

  return {
    loanId: loan_id ?? null,
    approved: !!approved,
    declined: !approved,
    command,
    params: {
      siteId: params?.site_id ?? null,
      externalApplicationId: params?.external_application_id ?? null,
      cost: params?.cost ?? null,
      transactionId: params?.transaction_id ?? null,
    },
  };
};
